import * as React from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import "../src/assets/css/toast.scss";

import Navigation from "./navigation";
import { toast, ToastContainer } from "react-toastify";
import { onMessage } from "firebase/messaging";
import { messaging } from "./firebase";
import { useDispatch, useSelector } from "react-redux";
import { MeCallRevised } from "./components/Common/ProfileDetails/MeCallRevised";
import {
  profileCompletionFlags,
  RegistrationIds,
} from "./assets/interface/primeSharkWebsite_interface";
import { FloatingCompleteProfile } from "./components/Common/floatingCompo/FloatingCompleteProfileProps ";
import { registrationId } from "./config/action";
import { handleFCMNotification } from "./components/notificationHandler";

const App = () => {
  let navigate = useNavigate();
  const activeLoginTypes = useSelector(
    (state: any) => state?.items?.storeActiveLoginType,
  );
  let account_type = activeLoginTypes?.account_type;
  let login_type = activeLoginTypes?.loginType;
  const access_token_available = localStorage.getItem("access_token");
  const dispatch = useDispatch();

  let userId = useSelector((state: any) => state?.items?.profileDetail?.id);

  const storeProfileCompletion: profileCompletionFlags = useSelector(
    (state: any) => state?.items?.profileCompletionFlags,
  ) ?? {
    has_investment_profile_completed: false,
    has_investment_subscription: false,
    has_want_to_sell_subscription: false,
    has_want_to_sell_profile_completed: false,
    has_want_to_grow_subscription: false,
    has_want_to_grow_profile_completed: false,
  };

  let {
    has_investment_profile_completed,
    has_investment_subscription,
    has_want_to_sell_subscription,
    has_want_to_sell_profile_completed,
    has_want_to_grow_subscription,
    has_want_to_grow_profile_completed,
    has_investment_subs,
    has_want_to_sell_subs,
    has_want_to_grow_subs,
    has_want_to_sell_free_subscription,
    has_investment_free_subscription,
    has_want_to_grow_free_subscription,
  } = storeProfileCompletion;
  const incompleteProfiles: string[] = [];

  if (has_investment_subscription && !has_investment_profile_completed) {
    incompleteProfiles.push("Capital Bridge");
  }
  if (has_want_to_sell_subscription && !has_want_to_sell_profile_completed) {
    incompleteProfiles.push("Business Exchange");
  }
  if (has_want_to_grow_subscription && !has_want_to_grow_profile_completed) {
    incompleteProfiles.push("Global Connect");
  }

  React.useEffect(() => {
    if (!userId) return;

    const unsubscribe = onMessage(messaging, (payload) => {
      const data = payload?.data ?? {};

      handleFCMNotification({
        data,
        userId,
        login_type,
        account_type,
        navigate,
      });
    });

    return () => unsubscribe();
  }, [userId, login_type, account_type, navigate]);

  React.useEffect(() => {
    if ("serviceWorker" in navigator) {
      const handleSwMessage = (event: MessageEvent) => {
        console.log("FCM Notification Received from Service Worker:", event.data);
      };
      navigator.serviceWorker.addEventListener("message", handleSwMessage);
      return () => {
        navigator.serviceWorker.removeEventListener("message", handleSwMessage);
      };
    }
  }, []);

  React.useEffect(() => {
    if (!access_token_available) return;
    meCall();
    const interval = setInterval(
      () => {
        meCall();
      },
      60 * 60 * 1000,
    );

    return () => clearInterval(interval);
  }, [access_token_available]);
  const FCMDeviceToken = useSelector(
    (state: any) => state?.items?.FCMDeviceToken,
  );
  const meCall = () => {
    let coming_from = "";
    MeCallRevised({
      navigate,
      dispatch,
      login_type,
      account_type,
      coming_from,
      FCMDeviceToken,
    });
  };
  const profile = useSelector((state: any) => state?.items?.profileDetail);
  const storeImpIdsInRedux = (impIds: RegistrationIds) => {
    dispatch(registrationId(impIds));
  };
  const handleTagNavigation = () => {
    const impIds: RegistrationIds = {
      uuid: profile?.uuid,
      business_uuid: profile?.basic_info?.entrepreneur_business_details?.uuid,
      account_type: account_type,
      login_type: login_type,
    };
    storeImpIdsInRedux(impIds);

    switch (true) {
      case (has_investment_subs || has_investment_free_subscription) &&
        !has_investment_profile_completed:
        navigate("/entrepreneur/investment/register");
        break;

      case (has_want_to_sell_subs || has_want_to_sell_free_subscription) &&
        !has_want_to_sell_profile_completed:
        navigate("/entrepreneur/want-to-sell/register");
        break;

      case (has_want_to_grow_subs || has_want_to_grow_free_subscription) &&
        !has_want_to_grow_profile_completed:
        navigate("/entrepreneur/want-to-grow/register");
        break;

      default:
        navigate("/dashboard");
    }
  };
  // React.useEffect(() => {
  //   const existing = document.getElementById("prime-shark-ai");

  //   if (existing) return;

  //   const script = document.createElement("script");

  //   script.id = "prime-shark-ai";

  //   script.src = "https://stageai.theprimeshark.com/shark_ai/embed.js";

  //   script.setAttribute("data-user-id", localStorage.getItem("user_id") || "");

  //   script.defer = true;

  //   document.body.appendChild(script);
  // }, []);

  const USER_ID = localStorage.getItem("user_id") || "";
  const chatbotURL = process.env.REACT_APP_CHATBOT_URL;

  React.useEffect(() => {
    if (!chatbotURL) return;

    const existingScript = document.getElementById("prime-shark-ai-script");

    if (existingScript) {
      existingScript.remove();
    }

    if ((window as any).PrimeSharkAI) {
      delete (window as any).PrimeSharkAI;
    }

    const script = document.createElement("script");
    script.id = "prime-shark-ai-script";
    script.src = chatbotURL;
    script.defer = true;

    if (USER_ID) {
      script.setAttribute("data-user-id", String(USER_ID));
    }

    document.body.appendChild(script);

    return () => {
      document.getElementById("prime-shark-ai-script")?.remove();
    };
  }, [USER_ID, chatbotURL]);

  // const chatbotURL = process.env.REACT_APP_CHATBOT_URL;
  // React.useEffect(() => {
  //   console.log("chatboturl",chatbotURL);

  //   if(!chatbotURL) return;
  //   const existingScript = document.getElementById("prime-shark-ai-script");

  //   // Remove existing script
  //   if (existingScript) {
  //     existingScript.remove();
  //   }

  //   // Clear existing global instance if embed.js uses one
  //   if ((window as any).PrimeSharkAI) {
  //     delete (window as any).PrimeSharkAI;
  //   }

  //   const script = document.createElement("script");
  //   script.id = "prime-shark-ai-script";
  //   script.src = chatbotURL;
  //   script.defer = true;

  //   if (USER_ID) {
  //     script.setAttribute("data-user-id", String(USER_ID));
  //   }

  //   document.body.appendChild(script);

  //   return () => {
  //     const script = document.getElementById("prime-shark-ai-script");
  //     script?.remove();
  //   };
  // }, [USER_ID]);

  return (
    <>

      <div className="App">
        <Navigation />
        <ToastContainer
          position="top-right"
          autoClose={3500}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
      {/* {localStorage.getItem("access_token") && (
        <FloatingCompleteProfile
          profiles={incompleteProfiles}
          onNavigate={handleTagNavigation}
        />
      )} */}
    </>
  );
};
export default App;
